/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CarePrincipalExportFinalSettingsEntity,
    CarePrincipalExportFinalSettingsEntityFromJSON,
    CarePrincipalExportFinalSettingsEntityFromJSONTyped,
    CarePrincipalExportFinalSettingsEntityToJSON,
} from './CarePrincipalExportFinalSettingsEntity';
import {
    CarePrincipalExportOverChargedSettingsEntity,
    CarePrincipalExportOverChargedSettingsEntityFromJSON,
    CarePrincipalExportOverChargedSettingsEntityFromJSONTyped,
    CarePrincipalExportOverChargedSettingsEntityToJSON,
} from './CarePrincipalExportOverChargedSettingsEntity';
import {
    CarePrincipalFinalizeSettingsEntity,
    CarePrincipalFinalizeSettingsEntityFromJSON,
    CarePrincipalFinalizeSettingsEntityFromJSONTyped,
    CarePrincipalFinalizeSettingsEntityToJSON,
} from './CarePrincipalFinalizeSettingsEntity';

/**
 * 
 * @export
 * @interface CarePrincipalSettingsEntity
 */
export interface CarePrincipalSettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    puServiceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    userManualUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    contractTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    contractLogo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettingsEntity
     */
    optInRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalSettingsEntity
     */
    exportDebitFormat?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettingsEntity
     */
    preliminaryStatusActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettingsEntity
     */
    exportCardsAutomatically?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettingsEntity
     */
    puPresentation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalSettingsEntity
     */
    orderCardEnabled?: boolean;
    /**
     * 
     * @type {Array<CarePrincipalExportFinalSettingsEntity>}
     * @memberof CarePrincipalSettingsEntity
     */
    carePrincipalExportFinalSettings?: Array<CarePrincipalExportFinalSettingsEntity>;
    /**
     * 
     * @type {Array<CarePrincipalFinalizeSettingsEntity>}
     * @memberof CarePrincipalSettingsEntity
     */
    carePrincipalFinalizeSettings?: Array<CarePrincipalFinalizeSettingsEntity>;
    /**
     * 
     * @type {Array<CarePrincipalExportOverChargedSettingsEntity>}
     * @memberof CarePrincipalSettingsEntity
     */
    carePrincipalExportOverChargedSettings?: Array<CarePrincipalExportOverChargedSettingsEntity>;
}

export function CarePrincipalSettingsEntityFromJSON(json: any): CarePrincipalSettingsEntity {
    return CarePrincipalSettingsEntityFromJSONTyped(json, false);
}

export function CarePrincipalSettingsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalSettingsEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'puServiceId': !exists(json, 'puServiceId') ? undefined : json['puServiceId'],
        'userManualUrl': !exists(json, 'userManualUrl') ? undefined : json['userManualUrl'],
        'contractTemplate': !exists(json, 'contractTemplate') ? undefined : json['contractTemplate'],
        'contractLogo': !exists(json, 'contractLogo') ? undefined : json['contractLogo'],
        'optInRequired': !exists(json, 'optInRequired') ? undefined : json['optInRequired'],
        'exportDebitFormat': !exists(json, 'exportDebitFormat') ? undefined : json['exportDebitFormat'],
        'preliminaryStatusActive': !exists(json, 'preliminaryStatusActive') ? undefined : json['preliminaryStatusActive'],
        'exportCardsAutomatically': !exists(json, 'exportCardsAutomatically') ? undefined : json['exportCardsAutomatically'],
        'puPresentation': !exists(json, 'puPresentation') ? undefined : json['puPresentation'],
        'orderCardEnabled': !exists(json, 'orderCardEnabled') ? undefined : json['orderCardEnabled'],
        'carePrincipalExportFinalSettings': !exists(json, 'carePrincipalExportFinalSettings') ? undefined : ((json['carePrincipalExportFinalSettings'] as Array<any>).map(CarePrincipalExportFinalSettingsEntityFromJSON)),
        'carePrincipalFinalizeSettings': !exists(json, 'carePrincipalFinalizeSettings') ? undefined : ((json['carePrincipalFinalizeSettings'] as Array<any>).map(CarePrincipalFinalizeSettingsEntityFromJSON)),
        'carePrincipalExportOverChargedSettings': !exists(json, 'carePrincipalExportOverChargedSettings') ? undefined : ((json['carePrincipalExportOverChargedSettings'] as Array<any>).map(CarePrincipalExportOverChargedSettingsEntityFromJSON)),
    };
}

export function CarePrincipalSettingsEntityToJSON(value?: CarePrincipalSettingsEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'carePrincipalId': value.carePrincipalId,
        'puServiceId': value.puServiceId,
        'userManualUrl': value.userManualUrl,
        'contractTemplate': value.contractTemplate,
        'contractLogo': value.contractLogo,
        'optInRequired': value.optInRequired,
        'exportDebitFormat': value.exportDebitFormat,
        'preliminaryStatusActive': value.preliminaryStatusActive,
        'exportCardsAutomatically': value.exportCardsAutomatically,
        'puPresentation': value.puPresentation,
        'orderCardEnabled': value.orderCardEnabled,
        'carePrincipalExportFinalSettings': value.carePrincipalExportFinalSettings === undefined ? undefined : ((value.carePrincipalExportFinalSettings as Array<any>).map(CarePrincipalExportFinalSettingsEntityToJSON)),
        'carePrincipalFinalizeSettings': value.carePrincipalFinalizeSettings === undefined ? undefined : ((value.carePrincipalFinalizeSettings as Array<any>).map(CarePrincipalFinalizeSettingsEntityToJSON)),
        'carePrincipalExportOverChargedSettings': value.carePrincipalExportOverChargedSettings === undefined ? undefined : ((value.carePrincipalExportOverChargedSettings as Array<any>).map(CarePrincipalExportOverChargedSettingsEntityToJSON)),
    };
}

